export default {
  buttons: {
    start: 'Rozpocznij przygotowanie zaplanowanego zamówienia',
  },
};
